'use strict';
const angular = require('angular');

export class CommunityLookupComponent {
  /*@ngInject*/
  constructor(CommunityService) {
    this.CommunityService = CommunityService;

    this.data = [];

    this.CommunityService.query((data) => {
      this.data = data;
      this.dataInitComplete = true;
    }, err => {
      console.log("Could not retrieve properties.")
    });
  }

  $onInit = function () {
    this.config = this.resolve.config;
  };

  ok(user) {
    this.close({$value: user});
  }

  cancel() {
    this.dismiss({$value: 'cancel'});
  }

  getPrimaryAddress(community) {
    let primary = community.address.find(addr => addr.isPrimary == true);

    if (!primary)
      return "-";

    return primary.street + "<br/>" + primary.city + ' ' + primary.state + ', ' + primary.zip;
  }
}

export default angular.module('conduu.communityLookup', [])
  .component('communityLookup', {
    template: require('./community-lookup.component.html'),
    bindings: {
      resolve: '<',
      config: '<',
      close: '&',
      dismiss: '&'
    },
    controller: CommunityLookupComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/community-lookup/community-lookup.component.js